import { Auction, Item, User } from '@/api';
import i18next from 'i18next';
import React from 'react';
import XIcon from 'public/assets/icons/x.svg';
import Checkmark from 'public/assets/icons/checkmark.svg';
import XRedIcon from 'public/assets/icons/x-red.svg';
import CheckmarkGreen from 'public/assets/icons/checkmark-green-body.svg';
import dayjs from 'dayjs';

type Props = {
    auction: Auction | undefined;
    isWinning: boolean | undefined;
    user: User | null;
    product: Item | undefined;
    isLoosing: boolean | undefined;
    hasUserAuctionAccess: boolean | undefined;
    hasLostAuction: boolean | undefined;

};

const PBCongrats = ({ auction, isWinning, isLoosing, hasUserAuctionAccess, hasLostAuction, product, user }: Props) => {
    if (hasUserAuctionAccess && hasLostAuction) {
        return (
            <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-grey14 rounded-[8px]">
                <span className="w-[24px] font-[500] mr-[5px]"><XIcon /></span> {i18next.t('alert-text.bid-alerts.you-were-outbid')}
            </div>
        );
    }
    if ((auction?.status === Auction.StatusEnum.Open || auction?.status === Auction.StatusEnum.Extended) && isLoosing === true) {
        return (
            <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center mb-4 bg-red3 text-red2 rounded-[8px]">
                <span className="w-[24px] font-[500] mr-[5px]"><XRedIcon /></span> {i18next.t('alert-text.bid-alerts.you-were-outbid-increase')}
            </div>
        );
    }

    if ((auction?.status === Auction.StatusEnum.Open || auction?.status === Auction.StatusEnum.Extended) && isWinning === true) {
        return (
            <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span> {i18next.t('alert-text.bid-alerts.you-are-the-highest')}
            </div>
        );
    }

    if (auction?.status === Auction.StatusEnum.Done && isWinning && dayjs().isBefore(dayjs(auction.end_date).add(1, 'week'))) {
        return (
            <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green4 text-green5 rounded-[8px]">
                <span className="w-[24px] font-[500] mr-[5px]"><Checkmark className="text-green5" /></span> {i18next.t('alert-text.bid-alerts.as-real-as-it-gets')}
            </div>
        );
    }
    if (product?.owner_id === user?.id && user?.id) {
        return (
            <div className="flex items-center text-[14px] leading-[14px] py-[10px] px-2 justify-center  mb-4 bg-green5 text-green4 rounded-[8px]">
                <span className="w-[24px] font-[500] mr-[5px]"><CheckmarkGreen /></span> {i18next.t('alert-text.bid-alerts.you-own-this-item')}
            </div>
        );
    }
};

export default PBCongrats;
